// Package imports:
import React from 'react';
// Component imports:
import DisplayBox from '../../DisplayBox/DisplayBox';
import Table from '../../../ui-elements/Table/Table';
import Link from '../../../ui-elements/Link/Link';
// Service imports:
import { insertDash, capitalize } from '../../../services/utils';
// Type imports:
import { IndividualMembership } from '../../../types/IndividualTypes';
import { IEventReport } from '../../../types/KeldanTypes';
import HeadSection from '../../../ui-elements/HeadSection/HeadSection';
import Alert from '../../../ui-elements/Alert/Alert';

interface IProps {
    report: IEventReport<IndividualMembership>,
    isExample?: boolean
}

const ViewMembershipBody: React.FC<IProps> = ({
    report,
    isExample = false
}) => {

    const displayName = () => {
        return report?.overview.member?.name ?? report?.overview.name ?? null;
    }

    const displayAddress = () => {
        if (report?.overview.includeAddress)
            return (report.overview.member?.address ?? report.overview.address) + ' - ' 
                + (report.overview.member?.zip ?? report?.overview.zip) + ' ' 
                + (report.overview.member?.city ?? report.overview.city)
        return '-'
    }

    return (
        <>
            <HeadSection
                title={
                    <div>
                        <h1>{displayName()}</h1>
                        <div className='individualInfo'>
                            <div className='individualInfo_col'>
                                <span className='individualInfo_title'>
                                    KENNITALA
                                </span>
                                <span className='individualInfo_value'>
                                    {insertDash(report.overview.member?.ssn ?? report.overview.ssn ?? '')}
                                </span>
                            </div>
                            {
                                (report.overview.includeAddress)
                                    ? <div className='individualInfo_col'>
                                        <span className='individualInfo_title'>
                                            PÓSTFANG
                                        </span>
                                        <span className='individualInfo_value'>
                                            {displayAddress()}
                                        </span>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                }
            />
            <div>
                <DisplayBox
                    title={`Aðild keypt ${report?.eventDate}`}
                    grayBackground={isExample}
                >
                    <div>
                        {(report.overview.member)
                            ? <Table
                                tableSize='lg'
                                data={report.overview.member.list}
                                columns={[{
                                    title: 'Félag',
                                    dataAccessor: ({name, companySsn}) => (
                                        <Link
                                            linkSize='15'
                                            url={`/Fyrirtaeki/Yfirlit/${companySsn}`}
                                            targetBlank
                                            disabled={isExample}
                                        >
                                            {name}
                                        </Link>
                                    ),
                                    textAlign: 'left',
                                    simpleSortable: ({name}) => name
                                }, {
                                    title: 'Kennitala',
                                    dataAccessor: ({companySsn}) => insertDash(companySsn)
                                }, {
                                    title: 'Afskráð',
                                    dataAccessor: ({unlisted, state_unlisted}) => (unlisted) ? `Afskráð ${state_unlisted}` : '',
                                }, {
                                    title: 'Hlutverk',
                                    dataAccessor: ({description_type, description_pos}) => (!description_pos) ? description_type : capitalize(description_pos),
                                }]}
                            />
                            : <Table
                                tableSize='lg'
                                data={report.overview.list?.list.list ?? []}
                                columns={[{
                                    title: 'Félag',
                                    dataAccessor: ({name, ssn}) => <Link linkSize='15' url={`/Fyrirtaeki/Yfirlit/${ssn}`} targetBlank>{name}</Link>,
                                    textAlign: 'left',
                                    simpleSortable: ({name}) => name
                                }, {
                                    title: 'Kennitala',
                                    dataAccessor: ({ssn}) => insertDash(ssn)
                                }, {
                                    title: 'Afskráð',
                                    dataAccessor: ({unlisted, state_unlisted}) => (unlisted === "J") ? `Afskráð ${state_unlisted}` : '',
                                }, {
                                    title: 'Hlutverk',
                                    dataAccessor: ({description_type, description_pos}) => (description_pos === null) ? description_type : description_pos,
                                }]}
                            />
                        }
                    </div>
                </DisplayBox>
            </div>
            <Alert
                type='info'
                headText='Athugið' 
                text={
                    <>
                        <p>Birtar upplýsingar eru sóttar með tengingu við Þjóðskrá. Allar upplýsingar eru veittar samkvæmt starfsreglum Þjóðskrár og í samræmi við lög og reglur um persónuvernd og meðferð persónuupplýsinga.</p>
                        <p>Reynt er að tryggja að upplýsingar séu réttar en Keldan getur ekki ábyrgst áreiðanleika þeirra.</p>
                    </>
                }
            />
        </>
    );
}

export default ViewMembershipBody;